/**
* @ngdoc component
* @name common.component:productItemCart
* @description
* This component consist in an input text and a button.
*/
(function() {
    'use strict';

    var productItemCart = {
        bindings: {
            item: '<',
            currency: '<',
            editable: '<',
            type: '<',
            onAction: '&',
            messageHasStock: '<',
            customized: '<'
        },
        controller: productItemCartCtrl,
        templateUrl: 'product-item-cart.component.html'
    };

    angular.module('itxApp.common')
        .component('productItemCart',productItemCart);

    productItemCartCtrl.$inject = [
        'ItxUtilsFct', 
        'ItxTranslateSvc',
        'ItxStaticResourceSvc',
        'productPopupSvc',
        'ProductViewedCacheSvc',
        'Product',
        'ItxShopCartFct',
        'logger',
        'itxAkamaiSvc',
        'CmsConfigSvc',
        'ItxSizeGuideSvc',
        'ItxConstants',
        '$scope',
        'timestampSvc'
    ];

    function productItemCartCtrl(
        ItxUtilsFct, 
        ItxTranslateSvc,
        ItxStaticResourceSvc,
        productPopupSvc,
        ProductViewedCacheSvc,
        Product,
        ItxShopCartFct,
        logger, 
        itxAkamaiSvc,
        CmsConfigSvc,
        ItxSizeGuideSvc,
        ItxConstants,
        $scope,
        timestampSvc
    ) {

        var _this = this;        
        _this.showItem = false;
        _this.imageNotLoaded = false;
        _this.product = null;
        _this.conf = {
            actionItem: function () {},
            messageStock: false,
            hotSku: false,
            color: true,
            size: true,
            quantity: true,
            reference: true,
            class: 'type-item',
            isEditable: false,
            actions: true,
            custom: false
        };

        _this.sku = '';
        _this.size = {};
        _this.color = {};
        _this.uniqueSize = false;

        _this.formatPrice = inditex.formatPrice.bind(inditex);
        _this.sizes = [];
        _this.showSizes = false;

        _this.preSaleTypeKey = '';

        _this.isLastUnits = false;

        _this.$onInit = function () {
            if(!_this.item){
                return;
            }
            _this.item = ItxShopCartFct.newItemCart(_this.item);

            _this.sku = _this.item.sku;
            
            // si no se especifica el mensaje de error mostramos el default
            if(!_this.messageHasStock){
                _this.messageHasStock = ItxTranslateSvc.translateCms('legacy.Messages_withoutStock');
            }

            // si no se especifica el tipo de item mostramos el default
            if(!_this.type){
                _this.type = {};
                _this.type.name = 'item-default';
            }

            // montamos la url para ticketless
            if(_this.item.fromStore){
                _this.storeImageUrl = '';
                ItxStaticResourceSvc.getStoreImageUrl(_this.item.reference).then(function(imageURL){
                    _this.storeImageUrl = `${inditex.iStoreJSON.details.imageBaseUrl}${imageURL}`;
                });
            }

            // Heredado del antiguo Item del shopcart
            _this.hasStock = _this.hasStockItem();
            _this.showSizeColor = !_this.item.state.isCard;
            _this.isEditable = _this.item.state.isCard && !_this.item.customization;

            if( _this.item.size == '01') {
                _this.oneSize = true;
            } else if(_this.item.state.selectedSize && _this.item.state.selectedSize.name == '01'){
                _this.oneSize = true;  
            } else {
                _this.oneSize = false;
            }

            // end

            // Si el item es una colonia
            // if(_this.item.isItemHazardousGood === 'true') {
            //     _this.conf.color = false;
            //     _this.conf.size = false;
            // }
            
            if (_this.item.state.isCard) {
                _this.conf.color = false;
                _this.conf.size = false;
                _this.conf.reference = false;
                _this.conf.class = 'type-card';
                _this.conf.quantity = false;

                // Obtenemos la imagen de la Gift card
                _this.giftcardImage = ItxStaticResourceSvc.getStatic() + 'itxwebstandard/images/giftcard/physical-image.png?t=' + timestampSvc.getTs();
                CmsConfigSvc.getProperty('giftcard_customize').then(function (giftCardTemplates) {
                    giftCardTemplates.giftcard_templates.forEach((template) => {
                        if (_this.item.style && _this.item.style === template.templateId) {
                            _this.giftcardImage = ItxStaticResourceSvc.getStatic() + template.pathimage + '?' + timestampSvc.getTs();
                        }
                    });
                });
            }

            // Dependiendo del tipo de item generamos las configuraciones de visualizacion y acciones
            switch (_this.type.name) {
                case 'item-mini-cart':
                    _this.conf.actionItem = _this.goToProductDetail;
                    _this.conf.actions = false;
                    _this.conf.isEditable = true;
                    break;
                case 'item-mini-cart-wishlist':
                    _this.conf.actionItem = _this.goToProductDetail;
                    _this.conf.actions = true;
                    _this.conf.isEditable = true;
                    break;
                case 'item-buylater':
                    _this.conf.actionItem = _this.goToProductDetail;
                    _this.conf.messageStock = true;
                    break;
                case 'buylater':
                    _this.conf.messageStock = true;
                    break;
                case 'item-shop-cart':
                    _this.conf.actionItem = _this.goToProductDetail;
                    _this.conf.messageStock = true;
                    _this.conf.isEditable = true;
                    break;
                case 'popup-add-to-cart':
                    _this.conf.quantity = false;
                    _this.conf.actions = false;
                    _this.conf.reference = false;
                    _this.conf.isEditable = false;
                    _this.conf.class = 'type-add-to-cart';
                    break;
                case 'item-my-account':
                    _this.conf.actionItem = _this.goToProductDetail;
            }

            if(!_this.item.state.xgift){
                _this.showItem = true;
            }

            // HOT SKU Si el producto es un regalo
            if(_this.item.isAutoAdd) {
                _this.conf = {
                    actionItem: function () {},
                    messageStock: false,
                    hotSku: true,
                    color: true,
                    size: true,
                    quantity: true,
                    reference: false,
                    class: 'type-free',
                    isEditable: false,
                    actions: false
                };

                if(_this.type === 'item-order-return'){
                    _this.conf.class += ' type-inactive';
                }
            }

            if(_this.item.customization && _this.item.customization.length>0){

                _this.conf.custom = true;
                _this.customization = _this.item.customization[0];
                

                // Traducir color
                if (_this.customization.color) {
                    _this.customization.color.translatedName = ItxTranslateSvc.translateCms(_this.customization.color.name.replace(' ', '_'))
                }

                _this.conf.actionItem = function () {};

                if(_this.type.name != 'item-my-account'){
                    _this.conf.actionItem = function () {};
                } else {
                    _this.conf.actionItem = _this.goToProductDetail;
                }

                if(_this.type === 'item-order-return'){
                    _this.conf.class = 'type-inactive';
                }

                //logger.log('ProductCustomizations ITEM -> ', _this.customization);

            }
            
            if(_this.conf.size){
                _this.sizeName = _this.getSizeName();
            }
            //Logica para calcular el origen de tienda
            var found = _.find(_this.item.stockLocations,function(location){
                if(location.stockSourceCode && location.stockSourceCode.indexOf('PST')>0){
                    return true;
                } else {
                    return false;
                }
            });

            if(found){
                CmsConfigSvc.getProperty('enable_message_item_from_shop').then(function(data){
                    
                    if(data){
                        
                        _this.conf.stockOrigin = true;
                    }
                    
                });
            }
            
            _this.isGift = _this.item.reference === 'XGIFTSKU';
            if(_this.isGift){
                _this.conf.isEditable = false;
            }
            _this.conf.loaded = true;

            const product = _this.getProduct(_this.item.parentId, _this.item.colorId, _this.size.sku, _this.item.set)
            if (product && product instanceof Product) {
                product.fetch().then(function (r) {
                    _this.product = r;
                    _this.setLastUnits();
                    _this.getSizes();
                }).Catch(function(err) {
                    console.err('err', err)                    
                });
            } else {
                _this.setLastUnits();
            }
            
            _this.setPreSaleTypeKey();
        };

        _this.setLastUnits = function () {
            if (_this.item.status && _this.item.status.selectedSize && _this.item.status.selectedSize.stockThreshold) {
                _this.isLastUnits = _this.item.status.selectedSize.stockThreshold === ItxConstants.DuttiLowThreshold ? true : false;
            } else if (_this.item.sku && _this.product && _this.product.stocks && _this.product.stocks.length) {
                const stock = _this.product.stocks.find((stock) => stock.id === _this.item.sku);
                if (stock && stock.typeThreshold) {
                    _this.isLastUnits = stock.typeThreshold === ItxConstants.DuttiLowThreshold ? true : false;
                }
            }
        };

        _this.setPreSaleTypeKey = function () {
            if (_this.item && _this.item.stockLocations && _this.item.stockLocations.length > 0) {
                if ('preSaleType' in _this.item.stockLocations[0]) {
                    switch (_this.item.stockLocations[0].preSaleType) {
                        // 1 PRE_SALE
                        case 1:
                            _this.preSaleTypeKey = 'dev.tunnel.shipping.extension.info1';
                            break;
                        // 2 PRE_ORDER
                        case 2:
                            _this.preSaleTypeKey = 'dev.tunnel.shipping.extension.info2';
                            break;
                        // toDo
                        case 3:
                            _this.preSaleTypeKey = '';
                            break;
                        // 4 PRESALE_PREORDER --> Preventa
                        case 4:
                            _this.preSaleTypeKey = 'dev.tunnel.shipping.extension.info4';
                            break;
                        // 5 PRESALE_SILO --> Desde AS400

                        case 5:
                            _this.preSaleTypeKey = 'dev.tunnel.shipping.extension.info5';
                            break;
                        // 6 PRESALE_PO --> Se carga desde CIS

                        case 6:
                            _this.preSaleTypeKey = 'dev.tunnel.shipping.extension.info6';
                            break;
                        // 7 PRESALE_MANUAL --> Preventa
                        case 7:
                            _this.preSaleTypeKey = 'dev.tunnel.shipping.extension.info7';
                            break;
                        // 0 NORMAL --> No se muestra ningún mensaje ya que es un stock normal
                        default:
                            _this.preSaleTypeKey = '';
                            break;
                    }
                }
            }
        };

        _this.isPreSalePreOrderAttribute = function () {
            return _this.item.attributes ? _this.item.attributes.map((attribute) => attribute.name).includes('MADEIN_PRESALEPREORDER') : undefined;
        };

        _this.getProductImageUrls = function (localization, imageType, imageSize) {
            // gift: ItxStaticResourceSvc.getImage('giftTicket/gift-box.jpg',true)
            if(_this.item.reference === 'XGIFTSKU'){
                return ItxStaticResourceSvc.getImage('giftTicket/gift-box.jpg',true);
            }
            var arrayImages = {};
            if(_this.item.fromStore && _this.storeImageUrl){
                return itxAkamaiSvc.useAkamaiImage(_this.storeImageUrl, 299);
            } else {
                arrayImages = ItxUtilsFct.getImageProductUrls(_this.item, _this.item.colorId, localization, imageType, imageSize);
                _this.imageNotLoaded = arrayImages.length === 0;
                return itxAkamaiSvc.useAkamaiImage(arrayImages[0], 299);
            }
        };

        _this.hasStockItem = function () {
            return (_this.item.availability === 'in_stock' || _this.item.quantity <= _this.item.unitsAvailable) && _this.item.unitPrice;
        };

        _this.stockSort = function() {
            return !_this.hasStock;
        }; 

        _this.viewProductDetail = function () {
            _this.goToProductDetail();
        };

        _this.goToProductDetail = function () {
            if (!_this.item.state.isCard && _this.item.reference !== 'XGIFTSKU') {
                ProductViewedCacheSvc.addProduct(_this.item.parentId,_this.item.colorId,null );                
                var product =  new Product(_this.item.parentId, _this.item.colorId);
                product.fetch().then(function(){
                    ProductViewedCacheSvc.addProduct(product.id, product.state.selectedColor.id,null);
                    window.open(product.getUrl(), '_blank');
                });
            }
        };

        _this.getSizeName = function () {
            let size = _this.item.size;
            if (!size && _this.item.state.selectedSize) {
                size = _this.item.state.selectedSize.name;
            }
            if (size === '01') {
                return ItxTranslateSvc.translateCms('legacy.one_size');
            } else {
                return size;
            }
        };

        _this.getProduct = function (productId, colorId, sku, set) {
            var product;
            if(!productId){
                return;
            }   
            if (productId instanceof Product && productId.id) {
                inditex.iProductId = productId.id;
                if (productId.fetched) {
                    product = productId;
                } else {
                    product = new Product(productId, colorId, null, productId.categoryId, sku, set);
                }
            } else {
                var categoryId = inditex.iCategoryId;
                if (_this.category) {
                    categoryId = _this.categoryId;
                }
                inditex.iProductId = productId;
                product = new Product(productId, colorId, null, categoryId, sku, set);
            }
            return product;
        };

        _this.getSizes = function () {
            if (_this.product) {
                _this.color = this.product.detail.colors.find((c) => c.id === _this.item.colorId);
                if (_this.color) {
                    _this.sizes = _this.color.sizes.filter(
                        (c) =>
                            c.visibilityValue !== 'DISABLED' ||
                            c.visibilityValue !== 'HIDDEN' ||
                            c.visibilityValue !== 'COMING_SOON' ||
                            c.visibilityValue !== 'BACK_SOON'
                    );
                    _this.sizes = ItxSizeGuideSvc.removeDuplicates(_this.sizes);
                    _this.size = _this.sizes.find((c) => _this.item.size === c.name);
                    if (_this.size !== undefined) {
                        _this.sku = _this.size.sku;
                    }
                    if (_this.sizes.length === 1 && _this.sizes[0].name === '01') {
                        _this.uniqueSize = true;
                    }
                    if (_this.sizes.length === 0) {
                        _this.showSizes = false;
                    } else {
                        _this.showSizes = true;
                    }
                    $scope.$digest();
                }
            }
        };

        _this.onSelectQuantity = function (quantity) {
            _this.onAction({
                action: 'update:quantity', 
                item: _this.item,
                value: quantity
            });
        };

        _this.onSelectSize = function () {
            _this.size = _this.sizes.find((c) => _this.sku === c.sku);
            const p = _this.getProduct(_this.item.parentId, _this.item.colorId, _this.size.sku, _this.item.set);
            p.fetch().then((r) => {
                r.quantity = _this.item.quantity;
                this.onAction({
                    action: 'update:size',
                    item: _this.item,
                    value: {
                        item: r,
                        color: _this.color,
                        size: _this.size
                    }
                });
            });
        };

        _this.showButtonAction = function (action) {
            // En caso de ser un producto personalizable, solo mostramos el botón de eliminar
            if(_this.item.customization && _this.item.customization.length > 0 || _this.item.productType === 'Virtual Card') {
                if(action.name === 'delete:shopcart') {
                    return true;
                }
                return false
            }
            
            if (action.isBuyable){
                return _this.hasStock;
            } else {
                return true;
            }

        };
        
    }

})();